import { format as buffer } from './buffer';
import { format as sparkplug } from './sparkplug';

const formats = [
    buffer,
    sparkplug
]

export { formats };


// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/formats/index.js